
/* De Goudhaan reveal observer */
(function() {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-gh-reveal]').forEach(function(el) {
      el.classList.add('is-revealed');
    });
    return;
  }
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-gh-reveal-delay') || '0', 10);
        if (delay > 0) {
          setTimeout(function() { el.classList.add('is-revealed'); }, delay);
        } else {
          el.classList.add('is-revealed');
        }
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function init() {
    document.querySelectorAll('[data-gh-reveal]').forEach(function(el) {
      observer.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
